import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { mapGraphQLErrors } from 'providers/graphql'
import { Schema } from '../../schema'
import { Data, toDTO, UPDATE_WORKSPACE_PRODUCT } from './api'
import { UseUpdateWorkspaceProduct } from './types'

export const useUpdateWorkspaceProduct = (): UseUpdateWorkspaceProduct => {
  const { t } = useTranslation('features/performance')
  const { enqueueSnackbar } = useSnackbar()
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})
  const [loading, setLoading] = useState<boolean>(false)

  const [mutateUpdateWorkspaceProduct] = useMutation(UPDATE_WORKSPACE_PRODUCT, {
    onCompleted: ({ updateWorkspaceProduct: { errors } }: Data): void => {
      setLoading(false)

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), { variant: 'error' })
      } else {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), { variant: 'success' })
      }
    },
    onError: (): void => {
      setLoading(false)
      enqueueSnackbar(t('form.error.update'), { variant: 'error' })
    },
    refetchQueries: ['getWorkspaceForPerformance'],
  })

  const updateWorkspaceProduct = (data: Schema) => {
    setLoading(true)

    return mutateUpdateWorkspaceProduct({
      variables: {
        input: toDTO(data),
      },
    })
  }

  return { errors, loading, updateWorkspaceProduct }
}
